import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import PeopleIcon from '@material-ui/icons/People'
import BallotIcon from '@material-ui/icons/Ballot'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import { useStyles } from './styles'
import { Grid } from '@material-ui/core'
import { useHistory, Link } from 'react-router-dom'

export default function AdminDrawer(props) {
  const classes = useStyles()
  const [counter, setCounter] = React.useState(props.remainingTime)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const isMenuOpen = Boolean(anchorEl)
  const history = useHistory()

  React.useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000)
  }, [counter])

  React.useEffect(() => {
    if(localStorage.token === undefined) {
      history.replace('/login')
    }
  })

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    localStorage.clear('token')
    history.replace('/login')
  }

  const menuId = 'primary-search-account-menu'
  const renderMenu = (
    <Drawer
      anchorEl={ anchorEl }
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={ menuId }
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={ isMenuOpen }
      onClose={ handleMenuClose }
    >
      <List justifyContent="center">
        <ListItem alignItems="center" style={{ textAlign: 'center' }}>
          <ListItemText>
            <Typography className={ classes.userName }>
              Olá, { props.userName }!
            </Typography>
          </ListItemText>
        </ListItem>
        <Divider />
        <Link to="/admin/surveys">
          <ListItem button>
            <ListItemIcon><BallotIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary={ 'Questionários' } />
          </ListItem>
        </Link>
        {
          props.userProfile === 'administrator' && (
            <>
              <Link to="/admin/users">
                <ListItem button>
                  <ListItemIcon><PeopleIcon fontSize="small" /></ListItemIcon>
                  <ListItemText primary={ 'Usuários' } />
                </ListItem>
              </Link>
              <Link to="/admin/comments">
                <ListItem button>
                  <ListItemIcon><QuestionAnswerIcon fontSize="small" /></ListItemIcon>
                  <ListItemText primary={ 'Comentários' } />
                </ListItem>
              </Link>
            </>
          )
        }
      </List>
      <Divider />
      <List>
        <ListItem button onClick={ handleLogout }>
          <ListItemIcon><ExitToAppIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary={ 'Sair' } />
        </ListItem>
      </List>
    </Drawer>
  )

  return (
    <div className={ classes.grow }>
      <AppBar position="static">
        <Toolbar style={{ alignItems: 'center' }}>
          <IconButton
            edge="start"
            className={ classes.menuButton }
            color="inherit"
            aria-label="open drawer"
            onClick={ handleMenuOpen }
          >
            <MenuIcon />
          </IconButton>
          <Box ml={ 2 } mr={ 5 }>
            <Typography className={ classes.title } variant="h4"><b>ISE</b>B3</Typography>
          </Box>
          <Grid container xs={ 12 } style={{ flexWrap: 'inherit', alignItems: 'center' }}>
            <Box py={ 1 }>
              <Grid container direction="column">
                <Grid item xs={ 12 }>
                  <Typography variant="p" style={{ fontWeight: 700 }}>
                    Ciclo 2024/2025 - Índice de Sustentabilidade Empresarial
                  </Typography>
                </Grid>
                <Grid item xs={ 12 }>
                  <Typography variant="p">Etapa Atual: Consulta Pública</Typography>
                </Grid>
              </Grid>
            </Box>
            <div className={ classes.grow } />
            <img
              height="50"
              width="62"
              alt="B3 Logo"
              src="https://iseb3-v2-platform-staging.s3.amazonaws.com/logo-b3.png"
            />
          </Grid>
        </Toolbar>
      </AppBar>
      { renderMenu }
    </div>
  )
}
